<template><section><template>
<h3>Affix</h3>
<div class="bs-docs-section">
  <div class="bs-example">
    <h3>
      <n3-affix :offset="0">
        <nav class="sidebar">
          <ul>
            <li>...</li>
            <li>...</li>
            <li>...</li>
          </ul>
        </nav>
      </n3-affix>
    </h3>
  </div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-affix</span> <span class="hljs-attr">:offset</span>=<span class="hljs-string">"0"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">nav</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"sidebar"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">ul</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">li</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">li</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">li</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">li</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">li</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">li</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">ul</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">nav</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-affix</span>&gt;</span>
</code></pre>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>offset</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">0</code></td>
<td>The pixel value from the top of the screen</td>
</tr>
</tbody>
</table>
</div>
</template>


</section></template>
<style scoped>
.sidebar{
  background-color: #fff;
  box-shadow: 1px 1px 10px #ddd;
  z-index: 10000;
  padding:10px;
}
pre[class*='language-']{
  position: static;
}
</style>
<script>
export default {

}
</script>


// WEBPACK FOOTER //
// n3AffixDocs.md?36aedfb6